import { util as fabricNativeUtils, FabricObject, Point as FabricPoint } from 'fabric';
import { Polygon } from 'polygon-clipping';

import getClipPath from 'editor/src/component/EditorArea/Spread/Page/MediaElement/getClipPath';
import { ObjectRect } from 'editor/src/component/EditorArea/Spread/Page/MediaElement/Image/types';
import { POINT_0_0 } from 'editor/src/component/EditorArea/useCanvasRotation';

function getTextClipPath(
  textRect: ObjectRect,
  fontSize: number,
  contentClipPolygons: Polygon[],
  contentClipPath: FabricObject | undefined,
) {
  // Fonts may render outside the selection box (descenders, ascenders, swashes).
  // Extend the clip rect by fontSize on each side (2× total extra).
  const padding = fontSize;
  const rotatedVector = fabricNativeUtils.rotatePoint(
    new FabricPoint(-padding, -padding),
    POINT_0_0,
    fabricNativeUtils.degreesToRadians(textRect.angle),
  );

  const extendedTextRect = {
    left: textRect.left + rotatedVector.x,
    top: textRect.top + rotatedVector.y,
    width: textRect.width + padding * 2,
    height: textRect.height + padding * 2,
    angle: textRect.angle,
  };

  return getClipPath(extendedTextRect, contentClipPolygons, false, contentClipPath);
}

export default getTextClipPath;
